export const textContainsHTML = (text: string): boolean => {
  let result: boolean = /<\/?[a-z][\s\S]*>/i.test(text);

  return result;
};
